import { categories } from '@/mocks/categories';
import { homeSeoContent } from '@/mocks/seoContent';

export default function CategoryGrid() {
  return (
    <section id="categories" className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-12">
          <div className="lg:w-1/2">
            <span className="block text-sm font-semibold text-foreground-400 uppercase tracking-[0.15em] mb-2">
              {homeSeoContent.categoriesSectionLabel}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl text-foreground-900 italic">
              {homeSeoContent.categoriesSectionTitle}
            </h2>
          </div>
          <div className="lg:w-1/2">
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
              {homeSeoContent.categoriesSectionDesc}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-foreground-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 md:h-56 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} - VigorBuy Spreadsheet category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-semibold uppercase tracking-wide">
                    {cat.name}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-semibold text-foreground-900 text-base group-hover:text-primary-600 transition-colors duration-200">
                  {cat.name}
                </h3>
                <p className="mt-1 text-sm text-foreground-500 flex items-center gap-1.5">
                  Browse {cat.name}
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold cursor-pointer hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap"
          >
            View All Categories on VigorBuy
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}